/**
 * 消息组件类型常量
 * 用于标识不同类型的消息组件
 */
export const MESSAGE_COMPONENT_TYPE = {
  // 文本相关
  TEXT: 'text',
  TEXT_AND_IMG: 'textAndImg',

  // 媒体相关
  IMG: 'img',
  STICKER: 'sticker',
  UPLOAD_FILE: 'uploadFile',

  // 卡片相关
  TEAM_CARD: 'teamCard',
  TEAM_CARD_V2: 'teamCardV2',
  TOOL_CARD: 'toolCard',
  INFO_CARD: 'infoCard',
  COMMENT_CARD: 'commentCard',
  CUSTOM_CARD: 'customCard',
  ANCCard: 'ANCCard',
  HEYBOX_GAME_CARD: 'heyboxGameCard',

  // 邀请相关
  TEAM_INVITE: 'teamInvite',

  // 帖子相关
  POST: 'post',
  POST_COMMENT: 'postComment',
  UNKNOWN_POST: 'unknownPost',

  // 投票相关
  VOTE: 'vote',
  VOTE_ANC: 'voteAnc',

  // 其他功能
  BOT: 'bot',
  WELCOME_MSG: 'welcomeMsg',
  CD_KEY: 'cdKey',
  PUNISH_NOTIFY: 'punishNotify',
  FIGHT: 'fight',
  MINI_PROGRAM: 'miniProgram',
  MINI_PRO_DETAIL: 'miniProDetail',
  SCREEN_SHARE_GIFT: 'screenShareGift',
  FEEDBACK_CARD: 'feedbackCard',
  CHAT_GROUP_UNIVERSAL: 'chatGroupUniversal',
  GROUP_ANNOUNCEMENT: 'groupAnnouncement',
  // 特殊类型（在 MessageFactory 中使用）
  WELCOME: 'welcome',
  LAUGHTER_TRACKER: 'laughter-tracker',
  USER: 'user',
  GLOBAL_TEAM_USER: 'global-team-user',
  TOP_TIP: 'top-tip',
  NONE: 'none',
} as const;
